import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
@Component({
  selector: 'app-admin-verify-documents',
  templateUrl: './admin-verify-documents.component.html',
  styleUrls: ['./admin-verify-documents.component.scss'],
})
export class AdminVerifyDocumentsComponent implements OnInit {
  documents: any = {};
  mouDocument: any;
  statusText: string;
  statusText1: string;
  reason: any;
  reasons: any;
  deleteApiPop: string = 'N';
  deleteApiPop1: string = 'N';
  constructor(public g: Globals, private api: ApiIntegration, private alertService: AlertService, private http: HttpClient, public user: User, private router: Router, private route: ActivatedRoute) {
    this.getList();
  }
  getList() {
    this.api.getKycAndMouDetailByAccountOwnerId(this.route.snapshot.params['id'], "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.documents = data;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }
  ngOnInit() { }
  verfiyMouDoc() {
    this.g.loaderDisplay = "display";
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyMOUDocument', {
      "accountOwnerId": this.route.snapshot.params['id'],
      "id": this.documents.id,
      "isVerified": "YES"
    }, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('Mou Document', 'Verified Successfully');
        this.getList();
        this.deleteApiPop = 'n';
      } else if (data['code'] == 404) {
        this.alertService.error('Error', data['message']);
        this.deleteApiPop = 'n';
        this.getList();
      } else if (data['code'] == 400) {
        this.alertService.error('Error', data['message']);
        this.deleteApiPop = 'n';
        this.getList();
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }


  RejectMouDoc() {
    if (this.reasons == '' || this.reasons === null || this.reasons === undefined || this.reasons === 'undefined') {
      this.statusText1 = 'Please select reason';
      return;
    }
    this.g.loaderDisplay = "display";
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyMOUDocument', {
      "accountOwnerId": this.route.snapshot.params['id'],
      "id": this.documents.id,
      "reason": this.reasons,
      "isVerified": "NO"
    }, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('MOU Document', 'Rejected Successfully');
        this.deleteApiPop = 'n';
        this.getList();
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }

  openPopup() {
    this.deleteApiPop = 'Y';
  }

  closePopup() {
    this.deleteApiPop = 'n';
    this.reasons = '';
    this.statusText1 = '';
  }
  openPopupKyc() {
    this.deleteApiPop1 = 'Y';
  }

  closePopupKyc() {
    this.deleteApiPop1 = 'n';
    this.reason = '';
    this.statusText = '';
  }

  verfiyKycDoc() {
    this.g.loaderDisplay = "display";
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyKYCProcess', {
      "accountOwnerId": this.route.snapshot.params['id'],
      "id": this.documents.id,
      "isVerified": "YES"
    }, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('KYC Document', 'Verified Successfully');
        this.deleteApiPop1 = 'n';
        this.getList();
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }


  RejectKycDoc() {
    if (this.reason == '' || this.reason === null || this.reason === undefined || this.reason === 'undefined') {
      this.statusText = 'Please select reason';
      return;
    }
    this.g.loaderDisplay = "display";
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyKYCProcess', {
      "accountOwnerId": this.route.snapshot.params['id'],
      "id": this.documents.id,
      "reason": this.reason,
      "isVerified": "NO"
    }, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('KYC Document', 'Rejected Successfully');
        this.deleteApiPop1 = 'n';
        this.getList();
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }


}
